export default {
  // Hero
  tenderHeroTag: "Services de Support d'Appels d'Offres",
  tenderHeroTitle1: "Services Experts de",
  tenderHeroTitle2: "Support d'Appels d'Offres",
  tenderHeroDesc: "Les spécialistes des achats d'AIP aident les entreprises à identifier, qualifier et remporter des appels d'offres gouvernementaux, des ONG et des institutions privées dans la région; y compris l'enregistrement des soumissionnaires sur les portails d'achats, la rédaction des offres, la conformité et le support complet de soumission.",
  tenderCtaListings: "Voir les Appels d'Offres Régionaux",
  tenderCtaRequest: "Demander un Support",
  tenderStat1: "Appels d'Offres Remportés",
  tenderStat2: "Secteurs Couverts",
  tenderStat3: "Pays de l'AE",
  tenderStat4: "Temps de Réponse",
  tenderServicesTitle: "Nos Services de Support d'Appels d'Offres",
  tenderService1: "Enregistrement des Soumissionnaires",
  tenderService1Desc: "Nous enregistrons votre entreprise sur les portails d'achats des gouvernements et institutions de l'AE",
  tenderService2: "Identification d'Appels d'Offres",
  tenderService2Desc: "Nous parcourons quotidiennement les portails nationaux et régionaux pour trouver vos meilleures opportunités",
  tenderService3: "Rédaction d'Offres",
  tenderService3Desc: "Préparation professionnelle d'offres techniques et financières par des spécialistes sectoriels",
  tenderService4: "Révision de Conformité",
  tenderService4Desc: "Vérifications réglementaires et d'éligibilité complètes avant soumission",
  tenderService5: "Propositions Financières",
  tenderService5Desc: "Stratégie de tarification compétitive avec sourcing de cautions et garanties",
  tenderService6: "Caution de Soumission & Garanties",
  tenderService6Desc: "Nous aidons les entreprises à acquérir les cautions de soumission et garanties requises pour participer aux appels d'offres sur les portails d'achats",
  tenderService7: "Caution de Bonne Exécution",
  tenderService7Desc: "Nous facilitons l'acquisition de cautions de bonne exécution et garanties contractuelles pour sécuriser votre contrat après attribution de l'appel d'offres",
  tenderTrustBadge: "AIP est une firme de support des achats enregistrée au Rwanda avec des partenariats actifs auprès des agences d'achats d'Afrique de l'Est.",

  // List
  listTag: "Appels d'Offres Régionaux",
  listTitle1: "Listes d'Appels d'Offres",
  listTitle2: "Régionaux",
  listDesc: "Appels d'offres actifs des gouvernements et institutions en Afrique de l'Est. Filtrez par pays ou secteur, puis cliquez sur un appel d'offres pour voir les détails et demander un support.",
  listFilterSector: "Tous les Secteurs",
  listFilterCountry: "Tous les Pays",
  listClear: "Effacer",
  listCount_one: "appel d'offres trouvé",
  listCount_other: "appels d'offres trouvés",
  listNoResults: "Aucun appel d'offres ne correspond à vos filtres",
  listNoResultsHint: "Essayez d'ajuster votre sélection",
  listColTitle: "Titre",
  listColSector: "Secteur",
  listColCountry: "Pays",
  listColDeadline: "Date Limite",
  listColStatus: "Statut",
  listView: "Voir",
  listToday: "Aujourd'hui",
  listLeft: "restant",

  // Modal
  modalNeedHelp: "Besoin d'aide pour préparer une offre gagnante pour cet appel d'offres?",
  modalRequestSupport: "Demander un Support d'Appels d'Offres",
  modalSubmitInterest: "Soumettre un Intérêt",

  // Support Form
  supportTag: "Obtenir un Support",
  supportTitle1: "Nos Services de",
  supportTitle2: "Support d'Appels d'Offres",
  supportDesc: "Nos spécialistes des appels d'offres gèrent tout de l'identification de l'opportunité à la soumission finale — y compris l'enregistrement de votre entreprise sur les portails d'achats des gouvernements et institutions privées en Afrique de l'Est.",
  supportService1: "Enregistrement des Soumissionnaires",
  supportService1Desc: "Nous enregistrons votre entreprise sur les portails d'achats des gouvernements et institutions privées en Afrique de l'Est pour que vous ne manquiez aucune opportunité.",
  supportService2: "Identification d'Appels d'Offres",
  supportService2Desc: "Nous surveillons les portails d'achats en Afrique de l'Est et vous alertons sur les opportunités pertinentes.",
  supportService3: "Rédaction & Stratégie d'Offres",
  supportService3Desc: "Rédaction professionnelle de propositions techniques et financières adaptées aux critères des évaluateurs.",
  supportService4: "Révision de Conformité",
  supportService4Desc: "Révision complète de la liste des documents pour garantir que votre soumission répond à toutes les exigences.",
  supportService5: "Support de Bout en Bout",
  supportService5Desc: "De la première lecture de l'avis au jour de la soumission — nous sommes avec vous à chaque étape.",
  supportService6: "Caution de Soumission & Garanties",
  supportService6Desc: "Nous vous aidons à acquérir les cautions de soumission, garanties d'appel d'offres et sécurités requises pour qualifier et participer aux opportunités d'achat.",
  supportService7: "Caution de Bonne Exécution",
  supportService7Desc: "Nous facilitons l'acquisition de cautions de bonne exécution et garanties contractuelles pour sécuriser votre obligation après avoir remporté un appel d'offres.",
  supportFormTitle: "Demander un Support d'Appels d'Offres",
  supportFormSubtitle: "Complétez le formulaire et notre équipe vous contactera dans les 24 heures.",
  supportFormSuccessTitle: "Demande Reçue!",
  supportFormSuccessBody: "Nos spécialistes des appels d'offres vous contacteront dans les 24 heures.",
  supportFormCompany: "Nom de l'Entreprise",
  supportFormContact: "Nom du Contact",
  supportFormEmail: "Email",
  supportFormPhone: "Téléphone",
  supportFormCountry: "Pays",
  supportFormRef: "Référence / Titre de l'Appel d'Offres",
  supportFormType: "Type de Support Nécessaire",
  supportFormInfo: "Informations Complémentaires",
  supportFormSubmit: "Demander un Support d'Appels d'Offres",
  supportFormSubmitInterest: "Soumettre un Intérêt",
  supportFormSelectSupport: "Sélectionnez le type de support",
  supportTypeRegistration: "Enregistrement des Soumissionnaires sur les Portails d'Achats",
  supportTypeIdentification: "Identification d'Appels d'Offres",
  supportTypeBidWriting: "Rédaction d'Offres",
  supportTypeCompliance: "Révision de Conformité",
  supportTypeFinancial: "Proposition Financière",
  supportTypeFull: "Gestion Complète de la Soumission",
  supportTypeBidBond: "Caution de Soumission & Garanties",
  supportTypePerformanceBond: "Caution de Bonne Exécution",
  supportTypeOther: "Autre",
  supportFormSelectCountry: "Sélectionnez un pays",
  searchTenderPlaceholder: "Rechercher un titre ou une référence d'appel d'offres...",
};